import { z } from 'zod';
export const applicationType = z.union([z.literal('cms'), z.literal('crm'), z.literal('generic'), z.literal('all')]);
export const CREATED_AT_FIELD = 'createdAt';
//# sourceMappingURL=structure.js.map